module.exports = __webpack_public_path__ + "static/media/docok.fa0fce49.svg";